<template lang="">
  <v-dialog v-model="isOpenDiaLog" width="620px">
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>CHI TIẾT KHOẢN {{ titleType.toUpperCase() }}</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text class="detail py-3">
        <h3>1. Thông tin cơ bản</h3>
        <div class="py-3">
          <v-row>
            <v-col :cols="5">
              <span>Nhóm</span>
            </v-col>
            <v-col :cols="4">
              <h4>{{ headFee.head_fee_collection && headFee.head_fee_collection.title }}</h4>
            </v-col>
          </v-row>
        </div>
        <div class="py-3">
          <v-row>
            <v-col :cols="5">
              <span> Khoản {{ titleType }} </span>
            </v-col>
            <v-col :cols="5">
              <h4>
                {{ headFee.title }}
              </h4>
            </v-col>
          </v-row>
        </div>
        <div class="py-3" v-if="router === 'priority' || (router === 'normal' && isSubFee === true)">
          <v-row>
            <v-col cols="5">
              <span>Áp dụng với khoản phí thu đóng</span>
            </v-col>
            <v-col cols="7">
              <h4>{{ headFee.head_fee_apply && headFee.head_fee_apply.title }}</h4>
            </v-col>
          </v-row>
        </div>
        <div class="py-3" v-if="isSubFee === false">
          <v-row>
            <v-col :cols="5">
              <span>Phân loại</span>
            </v-col>
            <v-col :cols="4">
              <h4>{{ headFee.category == 'default' ? 'Mặc định' : headFee.category == 'custom' ? 'Bổ sung' : '' }}</h4>
            </v-col>
          </v-row>
        </div>
        <div class="py-3" v-if="isSubFee === false">
          <v-row>
            <v-col :cols="5">
              <span>Loại hoá đơn</span>
            </v-col>
            <v-col :cols="4">
              <h4>
                {{ headFee.kind == 'cen' ? 'Học phí' : headFee.kind == 'decen' ? 'Thu hộ, chi hộ' : '' }}
              </h4>
            </v-col>
          </v-row>
        </div>
        <div class="py-3">
          <v-row>
            <v-col :cols="5">
              <span>Ghi chú</span>
            </v-col>
            <v-col :cols="5">
              <h4>{{ headFee.note }}</h4>
            </v-col>
          </v-row>
        </div>
        <h3>2. Thông tin hiển thị</h3>
        <div class="py-3">
          <v-row>
            <v-col :cols="5">
              <span>Tên hiển thị ngắn</span>
            </v-col>
            <v-col :cols="5">
              <h4>{{ headFee.metadata && headFee.metadata.shortName }}</h4>
            </v-col>
          </v-row>
        </div>
        <div class="py-3">
          <v-row>
            <v-col :cols="5">
              <span>Ưu tiên hiển thị</span>
            </v-col>
            <v-col :cols="5">
              <h4>{{ headFee.rank && headFee.rank }}</h4>
            </v-col>
          </v-row>
        </div>
        <div class="py-3">
          <v-row>
            <v-col :cols="5">
              <span>Ghi chú hiển thị</span>
            </v-col>
            <v-col :cols="5">
              <h4>{{ headFee.metadata && headFee.metadata.subNote }}</h4>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card outlined color="transparent">
        <v-divider></v-divider>
        <v-card-actions class="mt-5">
          <v-spacer />
          <v-btn
            v-if="
              ($auth.policies['update-head-fee'] && router === 'normal' && !isSubFee) ||
              ($auth.policies['update-dedution'] && router === 'priority' && !isSubFee) ||
              ($auth.policies['update-arrear-fee'] && router === 'normal' && isSubFee) ||
              ($auth.policies['update-refund-fee'] && router === 'priority' && isSubFee)
            "
            color="primary"
            outlined
            class="px-6 mr-4 mt-n4 mb-2 white--text"
            @click="$refs['updateDialog'].openDialog()"
            >Sửa hồ sơ chi tiết</v-btn
          >
        </v-card-actions>
        <HeadFeeUpdateDialog ref="updateDialog" style="margin: 0 20px" />
      </v-card>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import HeadFeeUpdateDialog from './headFeeUpdateDialog.vue'
export default {
  components: {
    HeadFeeUpdateDialog,
  },
  props: {
    headFee: Object,
  },
  data() {
    return {
      isOpenDiaLog: false,
      loading: false,
      updateDialog: false,
    }
  },
  computed: {
    ...mapState('tuitonFeeHeadFee', ['router', 'isSubFee']),
    titleType() {
      return this.$route.meta.title.replace('Chi tiết khoản', '')
    },
  },
  methods: {
    openDialog() {
      this.isOpenDiaLog = true
    },
    cancel() {
      this.isOpenDiaLog = false
    },
  },
}
</script>
<style lang="scss" scoped>
h3 {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #212121;
}
.detail h4 {
  color: black;
  font-weight: 400;
  font-size: 14px;
}
</style>
